import { $authHost } from "../../http";
import {
    PROTOCOL_STATE_GET_ERROR,
    PROTOCOL_STATE_GET_REQUEST,
    PROTOCOL_STATE_GET_SUCCESS
} from "../constants/protocolConstants";

export const getProtocolStates = (args) => async (dispatch) => {
    try {
        dispatch({
            type: PROTOCOL_STATE_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/protocolState/query",
            args || {},
            config,
        );
        dispatch({
            type: PROTOCOL_STATE_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: PROTOCOL_STATE_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

